import React, { useState } from 'react';
import { Typography, InputBase, Button, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import PasswordGuidelines from '~/_base/components/passwordGuidelines';

export default function CompleteSetup() {
  const classes = useStyles();
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');

  function handleRequestPasswordClick() {
    document.getElementsByTagName('form')[0].submit();
  }

  function handleKeyPress(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') {
      handleRequestPasswordClick();
    }
  }

  function shouldRender() {
    const elements = document.querySelectorAll(
      "[data-mount='ape_password_complete_setup']"
    );
    return elements.length > 0;
  }

  if (!shouldRender()) {
    return <div />;
  } else
    return (
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={6}>
          <PasswordGuidelines />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Typography variant="h1" className={classes.header}>
            Please enter a password to complete the setup
          </Typography>
          <div className={classes.inputContainer}>
            <InputBase
              onKeyPress={handleKeyPress}
              id="user_password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              name="user[password]"
              type="password"
              fullWidth
              placeholder="New password"
            />
          </div>
          <div className={classes.inputContainer}>
            <InputBase
              onKeyPress={handleKeyPress}
              id="user_password_confirmation"
              value={passwordConfirm}
              onChange={e => setPasswordConfirm(e.target.value)}
              name="user[password_confirmation]"
              type="password"
              fullWidth
              placeholder="Password confirmation"
            />
          </div>
          <div className="buttonContainer">
            <Button
              variant="contained"
              color="primary"
              className={classes.setPasswordButton}
              type="button"
              onClick={() => handleRequestPasswordClick()}
            >
              Set Password
            </Button>
          </div>
        </Grid>
      </Grid>
    );
}

const useStyles = makeStyles(theme => ({
  header: {
    marginBottom: theme.spacing(2),
  },
  inputContainer: {
    marginBottom: theme.spacing(1),
  },
  setPasswordButton: {
    width: '100%',
  },
  container: {
    maxWidth: 328,
    margin: '0 auto',
  },
}));
